import { Grid } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useLegalEntityContractData } from 'modules/contracts/lib/legalEntityContractDataContext'
import type ContractVersion from 'modules/contracts/store/models/ContractVersion'
import type Employee from 'modules/employees/store/models/Employee'
import policyAuthorizations from 'modules/permissions/store/collections/policyAuthorizations'

import Coefficient from './Coefficient'
import Echelon from './Echelon'
import EmployeeType from './EmployeeType'
import ForfaitJours from './ForfaitJours'
import JoursParAn from './JoursParAn'
import Mutuelle from './Mutuelle'
import Niveau from './Niveau'
import ProfessionalCategory from './ProfessionalCategory'

interface Props {
  contractVersion: ContractVersion
  employee: Employee
}

const France = ({ contractVersion, employee }: Props) => {
  const { frenchContractData } = useLegalEntityContractData()
  const canEdit = policyAuthorizations.for('contracts.edit', employee)
  const coefficient = contractVersion.attributes.fr_coefficient
  const professionalCategoryId = contractVersion.attributes.fr_professional_category_id
  const employeeTypeId = contractVersion.attributes.fr_employee_type
  const niveauId = contractVersion.attributes.fr_level_id
  const echelonId = contractVersion.attributes.fr_step_id
  const hasForfaitYours = !!contractVersion.attributes.fr_forfait_jours
  const joursParAn = hasForfaitYours ? contractVersion.attributes.fr_jours_par_an_cents : null
  const mutuelleId = contractVersion.attributes.fr_mutual_id

  const showCoefficient = !!coefficient || canEdit
  const showProfessionalCategory = !!professionalCategoryId || canEdit
  const showEmployeeType = !!employeeTypeId || canEdit
  const showNiveau = !!niveauId || canEdit
  const showEchelon = !!echelonId || canEdit
  const showJoursParAn = (hasForfaitYours && !!joursParAn) || canEdit
  const showMutuelle = !!mutuelleId || canEdit

  return (
    <Grid variant="fixed">
      {showCoefficient && <Coefficient coefficient={coefficient ?? undefined} />}
      {showProfessionalCategory && (
        <ProfessionalCategory
          categories={frenchContractData.professionalCategories}
          categoryId={professionalCategoryId ?? 0}
        />
      )}
      {showEmployeeType && (
        <EmployeeType types={frenchContractData.employeeTypes} employeeId={employeeTypeId ?? ''} />
      )}
      {showNiveau && <Niveau levels={frenchContractData.levels} niveauId={niveauId ?? 0} />}
      {showEchelon && <Echelon steps={frenchContractData.steps} echelonId={echelonId ?? 0} />}
      <ForfaitJours hasForfaitJours={hasForfaitYours} />
      {showJoursParAn && <JoursParAn joursInCents={joursParAn ?? undefined} />}
      {showMutuelle && (
        <Mutuelle mutuals={frenchContractData.mutuals} mutuelleId={mutuelleId ?? 0} />
      )}
    </Grid>
  )
}

export default observer(France)
